import { useMutation, useQueryClient } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useUpdateBusinessPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BusinessPlanApi.updateBusinessPlan,
    onSuccess: ({ uuid }) => {
      // TODO: refactor. Move this to place where need to update business plans
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlan(uuid) });
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlans(), exact: true });
    },
  });
};
